<template>
  <div class="about">
    <h1 align="center">RTL Logo</h1>
    <v-col cols="12">
      <v-layout>
        <v-flex xs8 sm6 offset-xs2 offset-sm3>
          <v-img src="https://d1wgggc35trcty.cloudfront.net/logo.png"></v-img>
          <v-card-text>
            <div class="text--primary font-weight-bold text-center">
              The RTL Logo symbolises the work of the RTL ministry. First started in 1978,
              it distributed audio recordings of sermons and messages through cassette
              tapes, in line with its theme verse “So then faith cometh by hearing, and
              hearing by the word of God” (Romans 10:17). The RTL ministry continues
              to carry on the work of distributing these recordings today, through the
              Life RTL web portal.
            </div>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-col>
  </div>
</template>
<script>
export default {
  name: "Logo",
  mounted: function() {
    window.scrollTo(0, 0);
  }
};
</script>
